import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { ImageStateService } from '../../services';

@Component({
  selector: 'cue-progressive-image',
  templateUrl: './progressive-image.component.html',
  styleUrls: ['./progressive-image.component.scss'],
  imports: [],
  providers: [ImageStateService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.height]': 'imgHeight()',
    '[style.max-height]': 'imgMaxHeight()',
    '[style.width]': 'imgWidth()',
  },
})
export class ProgressiveImageComponent {
  imgHeight = input<string>();
  imgMaxHeight = input<string>();
  imgWidth = input<string>();
}
